import React from "react";
import { TERMS_HTML } from "../UserOnboarding/MYPTermsAndConditions";

export default class MYPTermsAndConditions extends React.PureComponent {
  render() {
    return <div dangerouslySetInnerHTML={{ __html: TERMS_HTML }} />;
  }
}
